<div class="border-div">
  <div class="d-flex filter-header-rt floatinghead clearfix">
    <div class="rightside d-flex ml-auto">
      <div class="search-sec" style="padding-right: 10px" *ngIf="(!showNodataDD  && !showCAAcceptPending && !pendingApproval && !ddRequireApproval && !ddRequestRejected) || isfromSearch">
        <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
        <i aria-hidden="true" class="fa fa-search icon"></i>
      </div>
      <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown " *ngIf="(!showNodataDD  && !showCAAcceptPending && !pendingApproval && !ddRequireApproval && !ddRequestRejected) || isfromSearch">
         <mat-form-field  >
           <mat-select [(ngModel)]="categoryids"
                       [multiple]="true"
                       (selectionChange)="redrawTable()" placeholder="Select Categories">
             @if(categoryids?.length > 1) {
             <mat-select-trigger>
               <span>{{ categoryids.length }} items selected</span>
             </mat-select-trigger>
             }
             <mat-option *ngFor="let category of categoryLst" class="multi-dropdown-item" [value]="category.id">
               {{category.name}}
             </mat-option>
           </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="table-responsive" style="padding-top:30px; width: 100%" *ngIf="(!showNodataDD  && !showCAAcceptPending && !pendingApproval && !ddRequireApproval && !ddRequestRejected) || isfromSearch">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
      <thead>
        <tr>
          <th>#</th>
          <th>Document Name</th>
          <th>Date</th>
          <th>Category</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of dueDiligenceDocList; let i = index">
          <tr [ngClass]="{'highlighted' : item.Id == item.MaxValue}">
            <td>
              <p>{{i+1}}</p>
            </td>
            <td>
              <p>{{item.Name}}</p>
            </td>
            <td>
              <p>
                {{item.UploadedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(item.UploadedDate), 'MM/dd/yyyy')) : '-'}}
              </p>
            </td>
            <td>
              <p>{{item.Category}}</p>
            </td>
            <td>
              <a class="view" href={{item.FilePath}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                 ng-reflect-placement="top" triggers="hover" (click)="saveDueDiligenceToAuditLog()">
                <i aria-hidden="true" class="icofont icofont-download-alt"></i>
              </a>
              <a *ngIf="item.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', item)" placement="top">
                <i aria-hidden="true" class="fa fa-eye"></i>
              </a>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="isfromSearch && dueDiligenceDocList?.length == 0&&!IsLoading">
    <table class="table basictable row-border hover">
      <tr>
        <td colspan="5" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="nodata" *ngIf="showNodataDD && !isfromSearch">
    <p>Due Diligence materials are coming soon! Contact Broker for more details</p>
  </div>
  <div *ngIf="property.DDConfidentialityAgreement && docAccessOutput.IsCAAccepted != true" style="padding-top: 30px">
    <div *ngIf="showCAAcceptPending">
      <app-nda-agreement [ndaDetails]="ndaDetails"></app-nda-agreement>
      <div class="margin-top-30">
        <label class="custom-checkbox" for="checkboxTerms">
          <input class="border-checkbox" id="checkboxTerms" type="checkbox" [(ngModel)]="isDueDiligenceTandC">
          <i class="helper"></i>I agree to the above terms and conditions
        </label>
      </div>
      <div class="text-right">
        <button class="btn btn-success btn-lg" [disabled]="!isDueDiligenceTandC" (click)="onDueDiligenceProceedClick()">
          Proceed
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="(!property.DDConfidentialityAgreement || docAccessOutput.IsCAAccepted == true) && property.DueDiligenceReqApproval && (this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker) || this.authService.IsUserRole(this.authService.UserRole.Principal) || docAccessOutput.IsCAAccepted == true)">

    <div class="nodata" *ngIf="ddRequireApproval && !pendingApproval && !ddRequestRejected">
      <p>
        <span class="text">
          Due Diligence download requires Broker approval. <a class="blue-text" (click)="onDueDiligenceProceedClick()">Click here</a> to request access.
        </span>

      </p>
    </div>
  </div>


  <div *ngIf="pendingApproval">
    <h2 class="mainhead">
      <span class="text">
        Pending Approval
      </span>
    </h2>
    <div>
      Your download request is being processed. The documents will be available for download soon.
    </div>
  </div>
  <div *ngIf="ddRequestRejected">
    <h2 class="mainhead">
      <span class="text">
        Request Rejected
      </span>
    </h2>
    <div>
      Your request to view the Due Diligence documents has been rejected. Please get in touch with us to know more.
      <br />
      <b>Call : 646-770-0659</b>
      <br />
      <b>Email : info&#64;tradenetlease.com</b>
    </div>
  </div>

</div>

<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.FilePath" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

  <!--<pdf-viewer [external-link-target]="'blank'" [show-all]="true" [show-borders]="true" [original-size]="true" [src]="docPreview.Url"
              [render-text]="true"
              style="display: block;"></pdf-viewer>-->
</ng-template>

